import * as definitions from 'store/definitions/search';

export function searchCustomers(param) {
  return {
    type: definitions.SEARCH_CUSTOMERS_BY_PARAMS,
    payload: { param },
  };
}
